<template>
    <div>
        <base-modal
            v-if="open"
            @close="confirmed(false)"
        >
            <div slot="body">
                <div class="h5">
                    {{ message }}
                </div>
            </div>

            <div slot="footer">
                <button
                    class="btn btn-success mr-2"
                    @click="confirmed(true)"
                >
                    Oui
                </button>

                <button
                    class="btn btn-danger"
                    @click="confirmed(false)"
                >
                    Annuler
                </button>
            </div>
        </base-modal>
    </div>
</template>

<script>
    import BaseModal from "../templates/BaseModal"
    import Vue from 'vue'

    export default {
        name: "ConfirmModal",

        components: {BaseModal},

        data: function () {
            return {
                open: false,
                message: '',
                confirmed: null,
                ok: null,
            }
        },

        /**
         * Enregistre la fonction $confirm sur l'application Vue
         */
        created: function () {
            Vue.prototype.$confirm = message => this.confirm(message)
        },

        methods: {
            /**
             * Retourne une promesse qui permet de savoir si l'utilisateur confirme
             */
            confirm: function (message) {
                this.open = true
                this.message = message
                this.confirmed = null

                return new Promise((resolve, reject) => {
                    this.confirmed = response => {
                        this.open = false
                        response ? resolve() : () => {
                            if (reject) {
                                reject()
                            }
                        }
                    }
                })
            }
        }
    }
</script>
